import { render } from "./CreateOrganization.vue?vue&type=template&id=0630cc39&scoped=true"
import script from "./CreateOrganization.vue?vue&type=script&lang=js"
export * from "./CreateOrganization.vue?vue&type=script&lang=js"

import "./CreateOrganization.vue?vue&type=style&index=0&id=0630cc39&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0630cc39"]])

export default __exports__